import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { PartnerRedirectDialogData } from 'src/app/core/services/partner-redirect-dialog.service';

@Component({
  selector: 'app-modal-redirect-user-area-app',
  templateUrl: './modal-redirect-user-area-app.component.html',
  styleUrls: ['./modal-redirect-user-area-app.component.scss'],
})
export class ModalRedirectUserAreaApp {
  readonly agencySite: string | null;

  constructor(
    private dialogRef: MatDialogRef<ModalRedirectUserAreaApp>,
    @Inject(MAT_DIALOG_DATA) data: PartnerRedirectDialogData
  ) {
    this.agencySite = data?.agencySite ?? null;
  }

  get hasAgencySite(): boolean {
    return !!this.agencySite;
  }

  loginWithAnotherAccount(): void {
    this.dialogRef.close();
  }
}
